import { TaskTags } from 'enums/taskCategories';

export const NOT_ACTIVE_TASK_STATUSSES = ['Cancelled', 'Completed', 'Deleted'];

export const TASK_CATEGORIES = [
  { label: 'Messages', value: 'Messages' },
  { label: 'Post-consult', value: 'Post-consult' },
  { label: 'Appointments', value: 'Appointment' },
  { label: 'Requests', value: 'Requests' },
  { label: 'Requests • PA', value: 'Request • PA' },
  { label: 'Review', value: 'Review' },
  { label: 'Async', value: 'Async' },
  { label: 'Front desk', value: 'Front desk' },
  { label: 'Onboarding', value: 'Onboarding' },
  { label: 'Pre-consult', value: 'Pre-consult' },
  { label: 'Queue', value: 'Queue' }
];

export const TASK_STATUSES = [
  { bgColor: 'bg-gray-200', label: 'All', textColor: 'text-gray-700', value: 'All' },
  { bgColor: 'bg-red-100', label: 'Urgent', textColor: 'text-red-500', value: 'URGENT' },
  { bgColor: 'bg-secondary-100', label: 'New', textColor: 'text-secondary-500', value: 'New' },
  { bgColor: 'bg-yellow-100', label: 'Active', textColor: 'text-yellow-500', value: 'Active' },
  { bgColor: 'bg-primary-100', label: 'Open', textColor: 'text-primary-500', value: 'Open' },
  { bgColor: 'bg-orange-100', label: 'Pending', textColor: 'text-orange-500', value: 'Pending' },
  { bgColor: 'bg-gray-200', label: 'Cancelled', textColor: 'text-gray-700', value: 'Cancelled' }
];

export const CATEGORY_OPTIONS_HISTORY = [
  { label: 'Appointments task', value: 'appointment' },
  { label: 'Async', value: 'async' },
  { label: 'Appt • Async task', value: 'appointment-async' },
  { label: 'Pre-consult task', value: 'pre-consult' },
  { label: 'Onboarding task', value: 'onboarding' },
  { label: 'Messages task or response', value: 'message' },
  { label: 'Front desk task', value: 'front-desk' },
  { label: 'Requests task', value: 'request' },
  { label: 'PA request', value: 'pa-request' },
  { label: 'Post-consult task', value: 'post-consult' },
  { label: 'Review', value: 'review' },
  { label: 'Notifications', value: 'notification' },
  { label: 'App/Patient Activity', value: 'app/patient activity' },
  { label: 'Billing/Account', value: 'billing/account' },
  { label: 'System events', value: 'system' },
  { label: 'Automations', value: 'automations' },
  { label: 'Other', value: 'other' }
];

export const ASYNC_MESSAGE_TASKS = [TaskTags.UTI, TaskTags.PinkEye];

export const Appointment6sTags = [
  TaskTags.Nutrition,
  TaskTags.Sleep,
  TaskTags.Stress,
  TaskTags.Stillness,
  TaskTags.Social,
  TaskTags.Sweat
];
